 jQuery(function(){
	var claim = $('.header-claim');
	
	claim.each(function(index) {
		var claimWord = $(this);
		setTimeout(function() {
			claimWord.addClass('header-claim-visible');
		}, index*100+1000);
	});
 });